var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaregiversIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-786 -2084)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 10,
    transform: "translate(786 2084)",
    fill: "#ffbe8d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(838 2124)",
    fill: "#621bc0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(793.945 2090)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.055 6)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.827,
    height: 10.962,
    transform: "translate(26.442)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.827,
    height: 10.962,
    transform: "translate(11.035 4.617) rotate(-30.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.827,
    height: 10.962,
    transform: "translate(0 16.321) rotate(-60.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.962,
    height: 1.827,
    transform: "translate(44.304 20.22) rotate(-29.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.962,
    height: 1.827,
    transform: "translate(36.614 13.198) rotate(-60.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.331,56H5.827a1.827,1.827,0,0,0,0,3.654h47.5a1.827,1.827,0,0,0,0-3.654Z",
    transform: "translate(-2.223 -10.323)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.308,37.654V34H30.481v3.654a1.827,1.827,0,0,1-1.827,1.827H25v1.827h3.654a1.827,1.827,0,0,1,1.827,1.827V46.79h1.827V43.135a1.827,1.827,0,0,1,1.827-1.827H37.79V39.481H34.135A1.827,1.827,0,0,1,32.308,37.654Z",
    transform: "translate(-4.039 -8.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.357,26A17.376,17.376,0,0,0,13,43.357v8.222H47.714V43.357A17.376,17.376,0,0,0,30.357,26Zm-13.7,17.357v4.568H14.827V43.357a15.54,15.54,0,0,1,5.293-11.67l1.206,1.37a13.71,13.71,0,0,0-4.672,10.3ZM23.7,29.329l.785,1.65a13.711,13.711,0,0,0-1.707.969l-1.013-1.52a15.509,15.509,0,0,1,1.936-1.1ZM38.579,40.617a1.827,1.827,0,0,1-1.827,1.827H33.1V46.1a1.827,1.827,0,0,1-1.827,1.827H29.444A1.827,1.827,0,0,1,27.617,46.1V42.444H23.962a1.827,1.827,0,0,1-1.827-1.827V38.79a1.827,1.827,0,0,1,1.827-1.827h3.654V33.308a1.827,1.827,0,0,1,1.827-1.827h1.827A1.827,1.827,0,0,1,33.1,33.308v3.654h3.654a1.827,1.827,0,0,1,1.827,1.827Z",
    transform: "translate(-3.001 -7.729)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaregiversIcon1);
export default __webpack_public_path__ + "static/media/caregivers-icon1.adef0e2b7067cda0db62839716a9186c.svg";
export { ForwardRef as ReactComponent };